import { AltBtn, AltOutlineBtn } from "../../../buttons"
import { useCallback } from "react"

interface Props {
  takeOverConversation: () => void
  sendReply: () => void
  message: string
  setReplyMessage: (msg: string) => void
}

const LOFooter = ({
  takeOverConversation,
  sendReply,
  message,
  setReplyMessage
}: Props) => {
  const handleSendReply = useCallback(() => {
    sendReply()
  }, [sendReply])

  const handleEnterKey = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        handleSendReply()
      }
    },
    [handleSendReply]
  )

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setReplyMessage(e.target.value)
    },
    [setReplyMessage]
  )

  return (
    <div className="flex items-center">
      <div className="flex bg-neutral-50 rounded-lg pl-4 pr-2 py-2 flex-1 items-center focus:outline-none focus-within:ring-1 focus-within:ring-violet-500">
        <input
          type="text"
          value={message}
          onChange={handleChange}
          onKeyDown={handleEnterKey}
          className="appearance-none block w-full rounded-lg input-base border-none bg-transparent pl-0 pr-2 py-0 focus:outline-none focus:ring-0"
          placeholder="Chat directly with lead…"
        />
        <AltBtn
          className="ml-2 min-w-[76px]"
          onClick={handleSendReply}
          text="base"
          size="sm"
        >
          <span className="text-sm font-normal">Send</span>
        </AltBtn>
      </div>
      <AltOutlineBtn
        size="sm"
        className="ml-2 whitespace-nowrap h-10 px-3"
        text="base"
        onClick={takeOverConversation}
      >
        Handover to Katie
      </AltOutlineBtn>
    </div>
  )
}

export default LOFooter
